import { isValidPhoneNumber } from "react-phone-number-input";

export interface NewCustomerDraft {
  name: string;
  email: string;
  phone: string;
  notes: string;
}

export interface NewCustomerInput {
  name: string;
  email: string | null;
  phone: string | null;
  notes: string | null;
}

export type NewCustomerValidationErrors = Partial<Record<keyof NewCustomerDraft, string>>;

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const NAME_MAX_LENGTH = 200;
const EMAIL_MAX_LENGTH = 320;
const NOTES_MAX_LENGTH = 2000;

export const EMPTY_NEW_CUSTOMER_DRAFT: NewCustomerDraft = {
  name: "",
  email: "",
  phone: "",
  notes: "",
};

export function normalizeNewCustomerDraft(draft: NewCustomerDraft): NewCustomerInput {
  return {
    name: draft.name.trim(),
    email: draft.email.trim().toLowerCase() || null,
    phone: draft.phone.trim() || null,
    notes: draft.notes.trim() || null,
  };
}

export function validateNewCustomerDraft(draft: NewCustomerDraft): NewCustomerValidationErrors {
  const input = normalizeNewCustomerDraft(draft);
  const errors: NewCustomerValidationErrors = {};

  if (!input.name) errors.name = "Name is required";
  else if (input.name.length > NAME_MAX_LENGTH) errors.name = `Name must be ${NAME_MAX_LENGTH} characters or fewer`;

  // Email is optional, but every customer needs a way to be identified.
  if (!input.email && !input.phone) errors.email = "Add an email or a phone number";
  else if (input.email && input.email.length > EMAIL_MAX_LENGTH) errors.email = `Email must be ${EMAIL_MAX_LENGTH} characters or fewer`;
  else if (input.email && !EMAIL_PATTERN.test(input.email)) errors.email = "Enter a valid email address";

  if (input.phone && !isValidPhoneNumber(input.phone)) errors.phone = "Enter a valid phone number";
  if (input.notes && input.notes.length > NOTES_MAX_LENGTH) errors.notes = `Notes must be ${NOTES_MAX_LENGTH} characters or fewer`;

  return errors;
}
